import update from 'immutability-helper';

import * as ACTIONS from './actions';

const defaultState = {
    data: [],
    pagination: null,
    isLoading: false,
};

const ACTION_HANDLERS = {
    [ACTIONS.LOAD_DIVIDAS.INIT]: (state) =>
        update(state, {
            isLoading: { $set: true }
        }),

    [ACTIONS.LOAD_DIVIDAS.SUCCESS]: (state, action) => {
        var responseData = action.payload.data.data;
        return update(state, {
            data: { $set: responseData.data || [] },
            pagination: {
                $set: {
                    current_page: responseData.current_page,
                    last_page: responseData.last_page,
                    per_page: responseData.per_page,
                    total: responseData.total
                }
            },
            isLoading: { $set: false },
        });
    },

    [ACTIONS.LOAD_DIVIDAS.FAIL]: (state) =>
        update(state, {
            isLoading: { $set: false }
        }),

    [ACTIONS.CREATE_DIVIDA.SUCCESS]: (state, action) => {
        var newDivida = action.payload.data.data;
        return update(state, {
            data: { $unshift: [newDivida] }
        });
    },

    [ACTIONS.UPDATE_DIVIDA.SUCCESS]: (state, action) => {
        var updatedDivida = action.payload.data.data;
        return update(state, {
            data: {
                $set: state.data.map(function(item) {
                    return item.id === updatedDivida.id ? updatedDivida : item;
                })
            }
        });
    },

    [ACTIONS.DELETE_DIVIDA.SUCCESS]: (state, action) => {
        var deletedId = action.meta.previousAction.payload.id;
        return update(state, {
            data: {
                $set: state.data.filter(function(item) {
                    return item.id !== deletedId;
                })
            }
        });
    },

    [ACTIONS.ARCHIVE_DIVIDA.SUCCESS]: (state, action) => {
        var archivedId = action.meta.previousAction.payload.id;
        return update(state, {
            data: {
                $set: state.data.filter(function(item) {
                    return item.id !== archivedId;
                })
            }
        });
    },

    [ACTIONS.UNARCHIVE_DIVIDA.SUCCESS]: (state, action) => {
        var unarchivedId = action.meta.previousAction.payload.id;
        return update(state, {
            data: {
                $set: state.data.filter(function(item) {
                    return item.id !== unarchivedId;
                })
            }
        });
    },
};

var reducer = function(state, action) {
    if (state === undefined) {
        state = defaultState;
    }
    var handler = ACTION_HANDLERS[action.type];
    return handler ? handler(state, action) : state;
};

export default reducer;
